import { Injectable } from '@angular/core';
import { EntityStore, StoreConfig } from '@datorama/akita';
import { GeometricFormState } from '../../state/geometric-form.state';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'vertex' })
export class VertexStore extends EntityStore<GeometricFormState> {

  constructor() {
    super({
      ui: { visible: true },
      active: []
    });
    this.setLoading(false);
  }

}
